import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getOrganismos } from  "../../../services/OrganismoService";
import { getFueros } from  "../../../services/FueroService";
import { saveOrganismoFuero } from  "../../../services/OrganismoFueroService";
 

const initialState = {
  observaciones: "",
  circunscripcionJudicialOrganismo: "",
};

const circunscripcionJudicialOptions = [
  {
    id: "1",
    descripcion: "Primera",
  },
  {
    id: "2",
    descripcion: "Segunda",
  },
  {
    id: "3",
    descripcion: "Tercera",
  },
  {
    id: "4",
    descripcion: "Cuarta",
  }
];

const itemGender = "F";
const nameItemText = "Competencia";

const OrganismoFueroDialog = ({
  fueros,
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [organismosLocal, setOrganismosLocal] = useState([]);
  const [competenciasLocal, setCompetenciasLocal] = useState([]);
  const [valueAutoCompleteFueros, setValueAutoCompleteFueros] = useState(itemCrud.fuero);
  const [inputValueAutoCompleteFueros, setInputValueAutoCompleteFueros] = useState("");
  const [valueAutoCompleteOrganismos, setValueAutoCompleteOrganismos] = useState(itemCrud.organismo);
  const [inputValueAutoCompleteOrganismos, setInputValueAutoCompleteOrganismos] = useState("");
  const [valueAutoCompleteCompetencias, setValueAutoCompleteCompetencias] = useState(itemCrud.competencia);
  const [inputValueAutoCompleteCompetencias, setInputValueAutoCompleteCompetencias] = useState("");

  useEffect(() => {
    if (actionCrud === "create") {
      setValueAutoCompleteFueros("");
      setItemCrudLocal(initialState);
    } else {
      setValueAutoCompleteFueros(itemCrud.fuero);
      setValueAutoCompleteOrganismos(itemCrud.organismo);
      setValueAutoCompleteCompetencias(itemCrud.competencia);
      setItemCrudLocal(itemCrud);
      loadOrganismos(itemCrud.fuero, itemCrud.circunscripcionJudicialOrganismo);
      loadCompetencias();
    }
  }, []);

  const handleCloseDialog = () => {
    onClose();
  };


  const handleCircunscripcionChange = (event) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      circunscripcionJudicialOrganismo: event.target.value,
    });
    setValueAutoCompleteOrganismos("");
    setValueAutoCompleteCompetencias("");
    loadOrganismos(valueAutoCompleteFueros, event.target.value);
		loadCompetencias();
  };

  const handleFueroChange = (event, newValue) => {
    setValueAutoCompleteFueros(newValue);
    setValueAutoCompleteOrganismos("");
    setValueAutoCompleteCompetencias("");
    loadOrganismos(newValue, itemCrudLocal.circunscripcionJudicialOrganismo);
		loadCompetencias();
  };

  const handleSave = () => {
    if (actionCrud === "create" || actionCrud === "update") {
      if (inputValueAutoCompleteFueros === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Fuero",
        });
        setShowMessage(true);
        return;
      }

      if (inputValueAutoCompleteOrganismos === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Organismo",
        });
        setShowMessage(true);
        return;
      }

      if (inputValueAutoCompleteCompetencias === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar una Competencia",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };

  const save = async () => {
    let _itemCrud = {
      idFuero: valueAutoCompleteFueros?.id,
      idOrganismo: valueAutoCompleteOrganismos?.id,
      idCompetencia: valueAutoCompleteCompetencias?.id,
      usernameUsuarioActualiza: localStorage.getItem("emailUsuario"),
    };
    if (actionCrud !== "create") {
      _itemCrud.id = itemCrud.id;
    }
    setIsDoingSomething(true);
    const response = await saveOrganismoFuero(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  const loadOrganismos = async (fuero, circunscripcionJudicial) => {
    let _params = {
      idFuero: fuero?.id || valueAutoCompleteFueros?.id,
      circunscripcionJudicial: circunscripcionJudicial || itemCrudLocal.circunscripcionJudicialOrganismo,
    };
    setIsDoingSomething(true);

    const response = await getOrganismos(_params);
    setIsDoingSomething(false);
    if (response.ok) {
      let _response = response.data.data;
      let _organismos = [];
      _response.forEach((item) => {
        _organismos.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setOrganismosLocal(_organismos);
    } else {
      setOrganismosLocal([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };

  const loadCompetencias = async () => {
    let _params = {
      estado: 'habilitado',
    };
    setIsDoingSomething(true);
    const response = await getFueros(_params);
    setIsDoingSomething(false);
    if (response.ok) {
      let _response = response.data.data;
      let _competencias = [];
      _response.forEach((item) => {
        _competencias.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCompetenciasLocal(_competencias);
    } else {
      setCompetenciasLocal([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title"
          textAlign={{ xs: "center", sm: "center" }}
           
        >
          {actionCrud === "create"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : actionCrud === "disable"
                  ? "Deshabilitando"
                  : actionCrud === "read"
                    ? "Detalle"
                    : ""}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {isDoingSomething && <LinearProgress />}

        <DialogContent dividers>
          <Box sx={{ m: 1, p: 1 }}>
            <Autocomplete
              id="fuero"
              sx={{ width: "100%", pb: 1 }}
              size="small"
              value={valueAutoCompleteFueros}
              onChange={handleFueroChange}
              inputValue={inputValueAutoCompleteFueros}
              onInputChange={(event, newInputValue) => {
                setInputValueAutoCompleteFueros(newInputValue);
              }}
              options={fueros}
              renderInput={(params) => (
                <TextField {...params} label="Fuero" />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
              disableClearable={true}
            />
            <FormControl
              sx={{ width: "100%", pb: 1 }}
              disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
            >
              <InputLabel id="circunscripcionJudicial-select-label">
                Circunscripción Judicial
              </InputLabel>
              <Select
                sx={{ width: "100%", mr: 1 }}
                labelId="circunscripcionJudicial"
                label="Circunscripción Judicial"
                id="circunscripcionJudicialOrganismo"
                name="circunscripcionJudicial"
                value={itemCrudLocal.circunscripcionJudicialOrganismo}
                size="small"
                onChange={handleCircunscripcionChange}
              >
                {circunscripcionJudicialOptions.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Autocomplete
              id="organismo"
              sx={{ width: "100%", pb: 1 }}
              size="small"
              value={valueAutoCompleteOrganismos}
              onChange={(event, newValue) => {
                setValueAutoCompleteOrganismos(newValue);
                setValueAutoCompleteCompetencias("");
              }}
              inputValue={inputValueAutoCompleteOrganismos}
              onInputChange={(event, newInputValue) => {
                setInputValueAutoCompleteOrganismos(newInputValue);
              }}
              options={organismosLocal}
              renderInput={(params) => (
                <TextField {...params} label="Organismo" />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read" || !valueAutoCompleteFueros?.id || !itemCrudLocal.circunscripcionJudicialOrganismo}
            />

            <Autocomplete
              id="competencia"
              sx={{ width: "100%", pb: 1 }}
              size="small"
              value={valueAutoCompleteCompetencias}
              onChange={(event, newValue) => {
                setValueAutoCompleteCompetencias(newValue);
              }}
              inputValue={inputValueAutoCompleteCompetencias}
              onInputChange={(event, newInputValue) => {
                setInputValueAutoCompleteCompetencias(newInputValue);
              }}
              options={competenciasLocal}
              renderInput={(params) => (
                <TextField {...params} label="Competencia" />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "read"}
            />

            {actionCrud !== "create" && (
              <Box
                sx={{
                  p: 1,
                  mt: 1,
                  color: "SlateGrey",
                  border: "0px solid DarkGray",
                  borderRadius: "3px",
                }}
              >
                <Typography variant="h8" component="div" gutterBottom>
                  Fecha creación: {itemCrudLocal.fechaCreacion}
                </Typography>

                <Typography variant="h8" component="div" gutterBottom>
                  Usuario que creó: {itemCrudLocal.nombreUsuario}{" "}
                  {itemCrudLocal.apellidoUsuario} ({itemCrudLocal.username})
                </Typography>
              </Box>
            )}
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={handleCloseDialog}
              startIcon={<CloseIcon />}
            >
              Cancelar
            </Button>

            {(actionCrud !== "read") && (
              <Button
                sx={{ mr: 1, backgroundcolor: "warning" }}
                variant="contained"
                onClick={handleSave}
                startIcon={
                  actionCrud === "disable" ? (
                    <RemoveCircleOutlineIcon />
                  ) : actionCrud === "enable" ? (
                    <AddCircleOutlineIcon />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {actionCrud === "disable"
                  ? "Deshabilitar"
                  : actionCrud === "enable"
                    ? "Habilitar"
                    : "Guardar"}
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrganismoFueroDialog;
